var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"contact-page-test"},[_c('div',{staticClass:"contact full-w full-h"},[_c('NoPermissionInfo',{staticClass:"pt100"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }